module.exports = __webpack_public_path__ + "img/8.08b61fe4.webp";